import { render, staticRenderFns } from "./promoterDraweryh.vue?vue&type=template&id=1f683498&"
import script from "./promoterDraweryh.vue?vue&type=script&lang=js&"
export * from "./promoterDraweryh.vue?vue&type=script&lang=js&"
import style0 from "./promoterDraweryh.vue?vue&type=style&index=0&id=1f683498&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports